import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { style: {
                    width: '50em',
                } }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_text_field, {
      label: "Période comptable",
      variant: "outlined",
      readonly: "",
      "hide-details": "",
      class: _normalizeClass(_ctx.fullTextFieldClass),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPeriodSelector = true)),
      disabled: _ctx.disabled,
      "prepend-inner-icon": 
                _ctx.global
                    ? _ctx.selectedAccountingPeriod
                        ? '$oss-circle-check'
                        : '$oss-circle-uncheck'
                    : ''
            ,
      "append-inner-icon": 
                _ctx.selectedAccountingPeriod &&
                (_ctx.selectedAccountingPeriod.closed ||
                    _ctx.selectedAccountingPeriod.type === 'AccountingClosing')
                    ? '$lock_outline'
                    : ''
            ,
      "onClick:prependInner": _ctx.onPrependClick,
      "data-cy": "ossAccountingPeriodSelector-period",
      "model-value": _ctx.titleName,
      density: "comfortable"
    }, null, 8, ["class", "disabled", "prepend-inner-icon", "append-inner-icon", "onClick:prependInner", "model-value"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.showPeriodSelector,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showPeriodSelector) = $event)),
      title: _ctx.title
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_tabs, {
            modelValue: _ctx.step,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step) = $event)),
            "fixed-tabs": "",
            style: {"background-color":"transparent !important","border-radius":"16px","overflow":"hidden"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tab, {
                value: "periods",
                href: "#periods"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createElementVNode("strong", null, "Exercices", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_tab, {
                value: "closings",
                href: "#closings"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createElementVNode("strong", null, "Clôtures", -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_tabs_window, {
            modelValue: _ctx.step,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: "periods" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, {
                    style: {"overflow-y":"auto","height":"50vh"},
                    "model-value": _ctx.accountingPeriod ? _ctx.accountingPeriod.id : ''
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountingPeriods, (period) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: period.id
                        }, [
                          (
                                        (!period.accountingPeriod ||
                                            period.accountingPeriod.end !== period.end) &&
                                        period.type !== 'AccountingClosing'
                                    )
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 0,
                                onClick: ($event: any) => (_ctx.selectPeriod(period)),
                                rounded: "xl",
                                class: "mb-2",
                                lines: "two",
                                border: "",
                                "data-cy": 'ossAccountingPeriodSelector-' + period.id,
                                "model-value": period.id,
                                title: _ctx.getName(period),
                                subtitle: period.name ? _ctx.getPeriodString(period) : ''
                              }, {
                                append: _withCtx(() => [
                                  (
                                                period.type === 'AccountingClosing' || period.closed
                                            )
                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 0,
                                        start: ""
                                      }, {
                                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                                          _createTextVNode("$lock_outline")
                                        ])),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_icon, {
                                    end: "",
                                    color: "grey lighten-1",
                                    size: "x-small"
                                  }, {
                                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                                      _createTextVNode("$fa-chevron-right")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick", "data-cy", "model-value", "title", "subtitle"]))
                            : _createCommentVNode("", true),
                          (
                                        period.accountingSituations &&
                                        period.accountingSituations.length
                                    )
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(period.accountingSituations, (accountingSituation) => {
                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: accountingSituation.id,
                                  rounded: "xl",
                                  class: "mb-2",
                                  lines: "two",
                                  border: "",
                                  value: accountingSituation.id,
                                  onClick: ($event: any) => (_ctx.selectPeriod(accountingSituation)),
                                  "data-cy": 
                                            'ossAccountingPeriodSelector-' + accountingSituation.id
                                        ,
                                  title: _ctx.getAccountingSituationName(accountingSituation)
                                }, {
                                  append: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                                        _createTextVNode("$subdirectory_arrow_right")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  prepend: _withCtx(() => [
                                    (
                                                    period.type === 'AccountingClosing' ||
                                                    period.closed
                                                )
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          start: ""
                                        }, {
                                          default: _withCtx(() => _cache[9] || (_cache[9] = [
                                            _createTextVNode("$lock_outline")
                                          ])),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_v_icon, {
                                      end: "",
                                      color: "grey lighten-1",
                                      size: "x-small"
                                    }, {
                                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                                        _createTextVNode("$fa-chevron-right")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["value", "onClick", "data-cy", "title"]))
                              }), 128))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["model-value"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: "closings" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, {
                    style: {"overflow-y":"auto","height":"50vh"},
                    "model-value": _ctx.accountingPeriod ? _ctx.accountingPeriod.id : ''
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountingPeriods, (period) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (
                                        !period.accountingPeriod ||
                                        period.accountingPeriod.end !== period.end
                                    )
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: period.id,
                                value: period.id,
                                onClick: ($event: any) => (_ctx.selectPeriod(period)),
                                "data-cy": 'ossAccountingPeriodSelector-' + period.id,
                                title: _ctx.getName(period),
                                rounded: "xl",
                                class: "mb-2",
                                lines: "two",
                                border: "",
                                subtitle: period.name ? _ctx.getPeriodString(period) : ''
                              }, _createSlots({
                                append: _withCtx(() => [
                                  (
                                                period.type === 'AccountingClosing' || period.closed
                                            )
                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 0,
                                        start: ""
                                      }, {
                                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                                          _createTextVNode("$lock_outline")
                                        ])),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_icon, {
                                    end: "",
                                    color: "grey lighten-1",
                                    size: "x-small"
                                  }, {
                                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                                      _createTextVNode("$fa-chevron-right")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, [
                                (period.type === 'AccountingClosing')
                                  ? {
                                      name: "prepend",
                                      fn: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                          default: _withCtx(() => _cache[11] || (_cache[11] = [
                                            _createTextVNode("$subdirectory_arrow_right")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      key: "0"
                                    }
                                  : undefined
                              ]), 1032, ["value", "onClick", "data-cy", "title", "subtitle"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 256))
                    ]),
                    _: 1
                  }, 8, ["model-value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}